
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CircleDollarSign, CheckCircle2, Clock, XCircle, CreditCard } from 'lucide-react';

interface PaymentStatusBadgeProps {
  status: string;
  className?: string;
}

export const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ 
  status,
  className 
}) => {
  switch (status.toLowerCase()) {
    case 'paid':
    case 'completed':
      return (
        <Badge variant="success" className={className}>
          <CheckCircle2 className="h-3 w-3 mr-1" />
          Оплачен
        </Badge>
      );
    case 'pending':
      return (
        <Badge variant="warning" className={className}>
          <Clock className="h-3 w-3 mr-1" />
          Ожидание
        </Badge>
      );
    case 'error':
      return (
        <Badge variant="destructive" className={className}>
          <XCircle className="h-3 w-3 mr-1" />
          Отменен
        </Badge>
      );
    case 'auth':
      return (
        <Badge variant="outline" className={className}>
          <CreditCard className="h-3 w-3 mr-1" />
          Авторизация
        </Badge>
      );
    default:
      return (
        <Badge variant="secondary" className={className}>
          <CircleDollarSign className="h-3 w-3 mr-1" />
          {status}
        </Badge>
      );
  }
};
